import qs from 'querystring';
const requiredParams = {
  makes: ['yearId'],
  models: ['yearId', 'makeId'],
  trims: ['yearId', 'makeId', 'modelId'],
  vehicles: ['yearId', 'makeId', 'modelId', 'trimId']
};

/**
 * Client class to integrate the the KBB VRS services into ATC applications
 * @module VrsServiceClient
 */
class VrsServiceClient {
  /**
   * constructor for the KBB VRS Service client
   * @param {Function} vrsFetcher fetcher for general vehicle data (makes, models, etc...), vehicle valuations (via vehicleId), and specific vehicle data (vehicleId)
   */
  constructor() {
    let {
      vrsFetcher
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    this.vrsFetcher = vrsFetcher;
  }
  _getVrsData(endpoint) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const requiredKeys = requiredParams[endpoint.replace('/', '')];
    const missingValues = [];

    // Ensures all of the required fields are present before doing the fetch
    const hasRequiredParams = requiredKeys.reduce((acc, key) => {
      if (!query[key]) {
        missingValues.push(key);
        return false;
      }
      return acc;
    }, true);
    if (hasRequiredParams) {
      const querystring = qs.stringify({
        ...query,
        limit: 100
      });
      return this.vrsFetcher(`/data${endpoint}?${querystring}`);
    }

    // eslint-disable-next-line no-console
    console.error(`[VrsDataFetcher] - ${missingValues.join(', ')} parameters are all required for vrs endpoint /${endpoint}`);
    return null;
  }

  /**
   * @alias module:VrsServiceClient
   * @returns {Promise<*>}
   */
  async getYears() {
    return this.vrsFetcher('/data/years?limit=100&applicationFilter=Consumer&vehicleClass=UsedCar');
  }

  /**
   * @alias module:VrsServiceClient
   * @param query
   * @returns {Promise<*>}
   */
  async getMakes(query) {
    return this._getVrsData('/makes', query);
  }

  /**
   * @alias module:VrsServiceClient
   * @param query
   * @returns {Promise<*>}
   */
  async getModels(query) {
    return this._getVrsData('/models', query);
  }

  /**
   * @alias module:VrsServiceClient
   * @param query
   * @returns {Promise<*>}
   */
  async getTrims(query) {
    return this._getVrsData('/trims', query);
  }

  /**
   * @alias module:VrsServiceClient
   * @param query
   * @returns {Promise<*>}
   */
  async getVehicleId(query) {
    return this._getVrsData('/vehicles', query);
  }

  /**
   * @alias module:VrsServiceClient
   * @param kbbVehicleId
   * @returns {Promise<*>}
   */
  async getDetailsById(kbbVehicleId) {
    return this.vrsFetcher(`/data/vehicles/id/${kbbVehicleId}`);
  }

  /**
   * @alias module:VrsServiceClient
   * @param body
   * @returns {Promise<*>}
   */
  async getVehicleValuation(body) {
    return this.vrsFetcher('/valuation/values', {
      method: 'POST',
      body
    });
  }

  /**
   * @alias module:VrsServiceClient
   * @param kbbVehicleId
   * @returns {Promise<*>}
   */
  async getConsumerRatings(kbbVehicleId) {
    return this.vrsFetcher(`/editorial/consumerratings/id/${kbbVehicleId}`);
  }
}
export { VrsServiceClient as default };
